/* eslint-disable */
/* eslint no-undef: 0 */
/* eslint arrow-parens: 0 */
import React from 'react';
import { enquireScreen } from 'enquire-js';

import Footer0 from './Footer0';

import { Footer00DataSource, } from './data.source';
import { NewsDetailDataSource } from "../common/globalDataList";

import './less/antMotionStyle.less';
import Banner3 from "../News/Banner3";
import { Banner30DataSource } from "../News/data.source";

import BreadcrumbCon from "../components/BreadcrumbCon";
import NewsDetailCon from '../components/NewsDetailCon';

let isMobile;
enquireScreen((b) => {
    isMobile = b;
});

const { location } = window;

export default class Home extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isMobile,
        };
    }
    componentDidMount() {
        // 适配手机屏幕;
        enquireScreen((b) => {
            this.setState({ isMobile: !!b });
        });
    }

    render() {
        console.log("sessionStorage.newDetailIx", sessionStorage.newDetailIx)
        let newDetailIx = parseInt(sessionStorage.newDetailIx ? sessionStorage.newDetailIx : 0);
        let dataSource = window.newsList[newDetailIx];
        const children = [
            <Banner3
                id="Banner3_0"
                key="Banner3_0"
                dataSource={Banner30DataSource}
                isMobile={this.state.isMobile}
            />,
            <div className={"container"} style={{ height: '5vh', }}>
                <BreadcrumbCon pageName={"新闻资讯"} pagePath={"/news2"} />
            </div>,

            <div className={"container"} style={{ minHeight: '60vh', }}>
                <NewsDetailCon
                    title={dataSource ? dataSource['title'] : ""}
                    feTitle={dataSource ? dataSource['feTitle'] : ""}
                    // imgList={dataSource ? dataSource['imgList'] : ""}
                    textList={dataSource ? dataSource['textList'] : ""}
                    videoUrl={dataSource && dataSource['videoUrl'] ? dataSource['videoUrl'] : ""}
                    preInfo={newDetailIx > 0 ? window.newsList[newDetailIx - 1] : ""}
                    fixInfo={newDetailIx < window.newsList.length - 1 ? window.newsList[newDetailIx + 1] : ""}
                />
            </div>,
            <Footer0
                id="Footer0_0"
                key="Footer0_0"
                dataSource={Footer00DataSource}
                isMobile={this.state.isMobile}
            />,
        ];
        return (
            <div
                className="templates-wrapper"
                ref={(d) => {
                    this.dom = d;
                }}
            >
                {children}
            </div>
        );
    }
}
